"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

function replaceNbsps(str) {
  return str.replace(/\u00a0/g, " ");
}

exports.replaceNbsps = replaceNbsps;

function getTextContent(element) {
  if (react_1.default.isValidElement(element)) {
    // to exclude <style jsx></style>
    if (element.type === "style") {
      return "";
    } else {
      return react_1.default.Children.toArray(element.props.children).reduce(function (prevChild, currChild) {
        return prevChild + getTextContent(currChild);
      }, "");
    }
  } else {
    return "" + element;
  }
}

exports.getTextContent = getTextContent;